/* eslint-disable react/no-danger */
// Copyright (c) 2019 Deere & Company

import './home.scss';
import * as busyCounter from '../../shared/action-creator/busy-counter';
import moment from 'moment';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import { getAccessPrivileges, getNotifications } from '../../app/common/repositories';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { NavLink } from 'react-router-dom';

class Home extends Component {

    state = {
        privileges: {},
        notifications: [],
    };

    componentWillMount = () => {

        this.props.increaseCounter();
        getAccessPrivileges().then( response => {
            this.setState( { privileges: response } );
            this.props.decreaseCounter();
        } ).catch( () => {
            this.props.decreaseCounter();
        } );

        this.props.increaseCounter();
        getNotifications().then( response => {
            this.setState( { notifications: response } );
            this.props.decreaseCounter();
        } ).catch( () => {
            this.props.decreaseCounter();
        } );
        this.props.decreaseCounter();

    }

    render () {

        const alerts = ( this.state.notifications ).map( alert => (
            <tr key={alert.messageNumber} className="tbl-body">
                <td>{alert.messageDate ? moment( alert.messageDate * 1000 ).utc().format( 'DD MMM YYYY' ) : ''}</td>
                <td dangerouslySetInnerHTML={{ __html: alert.message }} />
            </tr>
        ) );

        return (
            <section className="home-placeholder">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />

                <header>
                    <h2 className="page-header"> Home </h2>
                </header>
                <main>
                    <h4>
                        <NavLink to={"/claims"}>Find Claims</NavLink>
                    </h4>
                    {this.state.privileges.worklistEditable && (
                        <h4>
                            <NavLink to={"/worklist"}>Worklist</NavLink>
                        </h4>
                    )}
                    {this.state.privileges.massUpdateEditable && (
                        <div>
                            <h4> Mass Updates </h4>
                            <h5>
                            <NavLink to= {"/massupdate/batch-factory-data-upload"}>Batch Factory Data Upload </NavLink>
                            </h5>
                            <h5>
                                <NavLink to={"/massupdate/analysis-comments-data-upload"}>Analysis Comments Data Upload </NavLink>
                            </h5>
                            <h5>
                                <NavLink to={"/massupdate/batch-text-upload"}>Text Extract Upload </NavLink>
                            </h5>
                            <h5>
                                <NavLink to={"/massupdate/batch-corrected-part_upload"}>Batch Upload Corrected Part Numbers </NavLink>
                            </h5>
                        </div>
                    )}
                    {this.state.privileges.adminScreenEditable && (
                        <div>
                            <h4> Admin </h4>
                            <h5>
                                <NavLink to={"/admin/warranty-code-maintainence"}>Warranty Product Structure Maintenance</NavLink>
                            </h5>
                            <h5>
                                <NavLink to={"/admin/function-code-maintainence"}>Function Code Maintenance</NavLink>
                            </h5>
                            <h5>
                                <NavLink to={"/admin/component-function-code-maintainence"}>Component Function Code Maintenance</NavLink>
                            </h5>
                            <h5>
                                <NavLink to={"/admin/part-group-maintainence"}>Part Group Maintenance</NavLink>
                            </h5>
                        </div>
                    )}

                    {Object.keys( this.state.notifications ).length > 0 && (
                        <table className="tbl-notifications">
                            <thead>
                                <tr className="tbl-header">
                                    <th colSpan="2">Alerts and messages</th>
                                </tr>
                                <tr className="tbl-col-header">
                                    <th>Date Posted</th>
                                    <th>Messages</th>
                                </tr>
                            </thead>
                            <tbody>
                                {alerts}
                            </tbody>
                        </table>
                    )}
                </main>
            </section>
        );

    }

}

Home.displayName = 'Home';
Home.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
};
const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
} );
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) ),
} );
export default connect( mapStateToProps, mapDispatchToProps )( Home );
